import { useEffect, useState } from "react"
import { HostsAutocompleteField } from "../../teamExperiences/components/AddExperienceSteps/fields/HostsAutocompleteField";
import { getHost } from "../../../services/teamExperienceService";
import { CommunityAdminHostModel } from "../models/CommunityAdminHostModel";

type Props = {
    hostId: number | null;
    onChangeHost: (host: CommunityAdminHostModel | null) => void;
}

export const CommunityAdminHostSelector = ({ hostId, onChangeHost }: Props) => {
    const [hostType, setHostType] = useState<"partner" | "member">("partner");
    const [listHost, setListHost] = useState<CommunityAdminHostModel[]>([]);
    
    const getUserListHosts = async () => {
        if(hostType === "member") {
            let params: any = {offset: 0, limit: 100};
            let hosts = await getHost(params);
            setListHost(hosts?.results)
        }
        else {
            let params = {offset: 0, limit: 100, type: 'partner'};
            let hosts = await getHost(params);
            setListHost(hosts?.results)
        }
    }

    useEffect(() => {
        getUserListHosts();
    }, [hostType]);

    const _handleSelect = (id: number | null, selectedHost?: any) => {
        if(id === null) {
            onChangeHost(null);
            return;
        }
        const _selected = selectedHost || listHost.find(l => l.id === id);
        onChangeHost(_selected ?? null);
    }

    return (
        <>
            <section className={`tap-add-experience-2-section d-flex`}>
                <label className="tap-add-experience-2-section-heading">Type Host</label>
                <div className="tap-add-experience-2-radio-row">
                    <div className={`tap-add-experience-2-radio-card ${hostType === "partner" ? 'tap-add-experience-2-radio-card--selected' : ''}`}>
                        <label className="tap-host-option p-6 w-100">
                            <input type="radio" className="tap-host-radio-input"
                                name="host_type"
                                value="partner"
                                checked={hostType === "partner"}
                                onChange={() => setHostType("partner")}
                            />
                            <div className="tap-host-radio">
                                <div className="tap-host-radio-outer"></div>
                                <div className="tap-host-radio-inner"></div>
                            </div>
                            <div className="tap-host-option-label">Partner</div>
                        </label>
                    </div>
                    <div className={`tap-add-experience-2-radio-card ${hostType === "member" ? 'tap-add-experience-2-radio-card--selected' : ''}`}>
                        <label className="tap-host-option p-6 w-100">
                            <input type="radio" className="tap-host-radio-input"
                                name="host_type"
                                value="member"
                                checked={hostType === "member"}
                                onChange={() => setHostType("member")}
                            />
                            <div className="tap-host-radio">
                                <div className="tap-host-radio-outer"></div>
                                <div className="tap-host-radio-inner"></div>
                            </div>
                            <div className="tap-host-option-label">Member</div>
                        </label>
                    </div>
                </div>
            </section>

            <section className="tap-add-experience-2-section">
                <label className="tap-add-experience-2-label">Host</label>
                <div>
                    <HostsAutocompleteField
                        hosts={listHost ?? []}
                        value={hostId}
                        onChange={_handleSelect}
                        placeholder="Select a host"
                        hostType={hostType}
                    />
                    <div className="tap-add-experience-2-input-hint mt-3">
                        Select the host of the experience
                    </div>
                    {!hostId &&
                        <div className="tap-add-experience-text text-danger">
                            Host is required
                        </div>
                    }
                </div>
            </section>
        </>
    )
}